import React from 'react'
import styles from './styles.module.scss'

function SuccessMessage({ text = '', className, html = '', children, center = false }) {
  return html && html.length > 0 ? (
    <div
      role='alert'
      aria-live='assertive'
      aria-atomic='true'
      aria-invalid='true'
      className={`${styles.success} ${className}  ${center && styles.center}`}
      {...(html && html.length > 0 ? { dangerouslySetInnerHTML: { __html: html } } : {})}
    />
  ) : (
    <div
      role='alert'
      aria-live='assertive'
      aria-atomic='true'
      aria-invalid='true'
      className={`${styles.success} ${className}  ${center && styles.center}`}>
      {text && text.length > 0 ? text : ''}
      {children ? children : null}
    </div>
  )
}

export default SuccessMessage
